import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { AppAutocomplete } from "./autocomplete/AppAutocomplete.tsx";
import { AutocompleteProvider } from "./autocomplete/context/GlobalContext.tsx";
import { ConfigProvider } from "./ConfigProvider.tsx";

const selector = "#algolia-autocomplete";

document.querySelectorAll<HTMLElement>(selector).forEach((container) => {
    const root = createRoot(container);
    root.render(
        <StrictMode>
            <ConfigProvider domElement={container}>
                <AutocompleteProvider>
                    <AppAutocomplete />
                </AutocompleteProvider>
            </ConfigProvider>
        </StrictMode>
    );
});
